export default [
    { key: 'name', label: 'Nombre' },
    { key: 'document', label: 'Documento' },
    { key: 'email', label: 'E-mail' },
    { key: 'client.name', label: 'Cliente' },
    { key: 'phone', label: 'phone' },
    { key: 'photo', label: 'Foto' }
]